import { inject, Injectable } from '@angular/core';
import { DownloadFile } from '@app/api-v2/util/file-io/download-file';
import { APIRequestBodyModel } from '@app/models/server/layout.model';
import { saveAs } from 'file-saver';
import { HttpErrorResponse } from '@angular/common/http';
import { ERROR_MESSAGES } from '@app/constants/message.constants';
import { ToastService } from '@app/services/util-services/root-services/toast-service';
import { LoaderUtilService } from '@app/services/loader/loader-util.service';
import { HttpClientService } from '@app/api-v2/util/http/http-client.service';

@Injectable()
export class WebDownloadFile extends DownloadFile {
  private httpClientService: HttpClientService;
  private toastService: ToastService;
  private loaderUtilService: LoaderUtilService;

  constructor() {
    super();
    this.httpClientService = inject(HttpClientService);
    this.toastService = inject(ToastService);
    this.loaderUtilService = inject(LoaderUtilService);
  }

  override downloadFile(
    apiUrl: string,
    body: APIRequestBodyModel,
    bookingPagePath: string,
  ) {
    this.httpClientService
      .post(apiUrl, body, {
        responseType: 'blob',
      })
      .subscribe({
        next: (result: any) => {
          if (result) {
            try {
              const blob: Blob = new Blob([result]);
              saveAs(blob, `${body?.fileName}`);
            } catch (e) {
              console.error('Error is ', e);
            }
          }
          this.loaderUtilService.hide();
        },
        error: (errorResponse: HttpErrorResponse) => {
          this.loaderUtilService.hide();
          if (errorResponse?.error?.errorCode) {
            this.toastService.showApiError(errorResponse);
          } else {
            this.toastService.error(ERROR_MESSAGES.VOUCHER_DOWNLADING_ERROR);
          }
        },
      });
  }
}
